import * as React from "react"
import Footer from "../components/Footer"
import Navbar from "../components/Navbar"
import Banner from "../components/Banner"
import "./all.sass"
import Link from "./Link"
import { navigationItems } from "./navigation"

const TemplateWrapper = ({ children }) => {
  return (
    <div>
      <div className="sticky">
        <Banner
          text="Join Teamspective Weekly Webinar & Product Demo - "
          cta={
            <Link to="https://hs.teamspective.com/weekly-webinars">
              Click to register
            </Link>
          }
        />
        <Navbar navigationItems={navigationItems} />
      </div>
      <main>{children}</main>
      <Footer navigationItems={navigationItems} />
    </div>
  )
}

export const PreviewTemplateWrapper = ({ children }) => (
  <>
    <Banner
      text="Improving team performance at scale – A short guide"
      cta={
        <Link to="https://hs.teamspective.com/ebook-high-performing-teams-0">
          Get the eBook
        </Link>
      }
    />
    <Navbar navigationItems={navigationItems} />
    <main>{children}</main>
  </>
)

export default TemplateWrapper
